var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShoppingCartRed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.562,
    height: 20.127,
    viewBox: "0 0 22.562 20.127",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "shopping-cart_1_",
    "data-name": "shopping-cart (1)",
    transform: "translate(0 -27.093)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2169",
    "data-name": "Group 2169",
    transform: "translate(5.751 43.387)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2168",
    "data-name": "Group 2168"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_176",
    "data-name": "Ellipse 176",
    cx: 1.917,
    cy: 1.917,
    r: 1.917,
    fill: "#dc3a1a"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2171",
    "data-name": "Group 2171",
    transform: "translate(13.418 43.387)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2170",
    "data-name": "Group 2170"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_177",
    "data-name": "Ellipse 177",
    cx: 1.917,
    cy: 1.917,
    r: 1.917,
    fill: "#dc3a1a"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2173",
    "data-name": "Group 2173",
    transform: "translate(0 27.093)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2172",
    "data-name": "Group 2172",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17441",
    "data-name": "Rectangle 17441",
    width: 3.834,
    height: 1.917,
    fill: "#dc3a1a"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2175",
    "data-name": "Group 2175",
    transform: "translate(2.875 27.093)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2174",
    "data-name": "Group 2174",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8594",
    "data-name": "Path 8594",
    d: "M66.473,30.928l-.556-3.834h-.958L64,27.228l2.041,14.242H79l4.687-10.543H66.473Zm11.281,8.626H67.709l-.958-6.709H80.734Z",
    transform: "translate(-64 -27.094)",
    fill: "#dc3a1a"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingCartRed);
export default __webpack_public_path__ + "static/media/shopping-cart-red.b3e4b848160e197e80dff095896959fc.svg";
export { ForwardRef as ReactComponent };